<template>
  <div class="text-left">
    <h5 class="font-weight-bold text-primary">Syarat & Ketentuan</h5>
    <b-row class="mt-4">
      <b-col md="4" class="my-1">
        <b-form-group class="mb-0">
          <b-input-group>
            <b-form-input v-model="filter" placeholder="Search"></b-form-input>
            <b-input-group-append>
              <b-button variant="primary" :disabled="!filter" @click="filter = ''">Clear</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="2" class="my-1" align="right">
        <b-form-group label-cols-sm="6" label="Show" class="mb-0">
          <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
        </b-form-group>
      </b-col>
      <b-col md="1" class="my-1"></b-col>
      <b-col md="2" align="right" class="my-1">
        <b-input-group>
          <b-input-group-text class="bg-white border-right-0" slot="prepend">
            <img src="@/assets/filter.svg" alt />
          </b-input-group-text>
          <b-dropdown
            text="Filter Data"
            variant="light"
            toggle-class="bg-white border-secondary text-primary border-left-0 pl-0"
            slot="append"
          >
            <b-dropdown-item @click="TncFilter()">All Category</b-dropdown-item>
            <b-dropdown-item
              @click="TncFilter(filter.id)"
              v-for="filter in dataTncCategory"
              :key="filter"
            >{{filter.name}}</b-dropdown-item>
          </b-dropdown>
        </b-input-group>
      </b-col>
      <b-col md="3" class="my-1" align="right">
        <router-link :to="{name: 'createTncContent'}">
          <b-button variant="primary">
            <img src="@/assets/create-new.svg" class="mr-2" alt />Create New
          </b-button>
        </router-link>
      </b-col>
    </b-row>
    <b-row>
      <br />
    </b-row>
    <section v-if="errored">
      <p>We're sorry, we're not able to retrieve this information at the moment, please try back later</p>
    </section>
    <!-- Main table element -->
    <b-table
      v-else
      responsive
      show-empty
      hover
      ref="selectableTable"
      :items="getInfo"
      :fields="key"
      :current-page="currentPage"
      :per-page="perPage"
      :filter="filter"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      @filtered="onFiltered"
      head-variant="light"
      class="bg-white"
    >
      <div slot="table-busy" class="text-center text-primary my-2">
        <b-spinner class="align-middle"></b-spinner>
        <strong>Loading...</strong>
      </div>
      <template v-slot:cell(content.id)="row">
        <div v-html="row.value.substring(0,20)"></div>
      </template>
      <template v-slot:cell(created_at_date_only)="{ value, item }">
        <p class="mb-0">{{item.created_at_date_only}}</p>
        by {{item.created_by_username}}
      </template>
      <template v-slot:cell(updated_at_date_only)="{ value, item }">
        <div v-if="item.updated_at_date_only == ''">-</div>
        <div v-else>
          <p class="mb-0">{{item.updated_at_date_only}}</p>
          by {{item.updated_by_username}}
        </div>
      </template>
      <template v-slot:cell(action)="{ value, item }">
        <router-link
          v-b-tooltip.hover
          title="Edit"
          :to="{name: 'editTncContent', params: {id: item.tnc_id}}"
          class="text-dark"
        >
          <img src="@/assets/ic-edit.svg" class="mr-2" alt />
        </router-link>
        <b-link
          v-b-tooltip.hover
          title="View Detail"
          @click="modalShow = !modalShow"
          class="text-dark mr-2"
        >
          <img @click="getDetail(item.tnc_id)" src="@/assets/ic-view-detail.svg" alt />
        </b-link>
        <b-link
          v-b-tooltip.hover
          title="Delete"
          class="text-dark"
          @click="del({id:item.tnc_id,interface:item.interface})"
        >
          <img src="@/assets/rectangle.svg" class="mr-2" alt />
        </b-link>
        <b-link
          :class="{'order-link':item.order_field === 1}"
          @click="orderTnc({id:item.tnc_id,change:'up'})"
          class="text-primary"
          v-b-tooltip.hover
          title="Order Up"
        >
          <i class="fas fa-arrow-up mr-2"></i>
        </b-link>
        <b-link
          :class="{'order-link':item.is_last_order}"
          @click="orderTnc({id:item.tnc_id,change:'down'})"
          class="text-primary"
          v-b-tooltip.hover
          title="Order Down"
        >
          <i class="fas fa-arrow-down"></i>
        </b-link>
      </template>
    </b-table>

    <b-row class="mx-auto">
      <b-col md="4" class="mx-auto px-0">Total entries {{rows}}</b-col>
      <b-col md="4" class="mx-auto"></b-col>
      <b-col md="4" align="right" class="px-0">
        <b-pagination
          align="right"
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          class="my-0"
        ></b-pagination>
      </b-col>
    </b-row>
    <b-modal v-model="modalShow" size="lg" ok-only hide-header>
      <b-row>
        <b-col>
          <h5 class="font-weight-bold">Preview</h5>
        </b-col>
        <b-col class="text-right">
          <i class="fas fa-times" @click="modalShow = !modalShow" style="cursor: pointer;"></i>
        </b-col>
      </b-row>
      <br />
      <b-row>
        <b-col md="6">
          <b-row>
            <b-col md="12" class="font-weight-bold">Title:</b-col>
            <b-col md="4" class="font-weight-bold">In Bahasa</b-col>
            <b-col md="8">{{modalShow ? detail.title.id:''}}</b-col>
            <b-col md="4" class="font-weight-bold">In English</b-col>
            <b-col md="8">{{modalShow ? detail.title.en:''}}</b-col>
            <br />
            <br />
            <b-col md="12" class="font-weight-bold">Content:</b-col>
            <b-col md="4" class="font-weight-bold">In Bahasa</b-col>
            <b-col md="8" v-html="modalShow ? detail.content.id:''"></b-col>
            <b-col md="4" class="font-weight-bold">In English</b-col>
            <b-col md="8" v-html="modalShow ? detail.content.en:''"></b-col>
            <br />
            <br />
          </b-row>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: true,
      modalShow: false,
      errored: false,
      items: [],
      detail: [],
      key: [
        {
          key: "created_at_date_only",
          label: "Created",
          sortable: true,
          class: "text-left"
        },
        {
          key: "tnc_category.name",
          label: "Category",
          sortable: true,
          class: "text-left"
        },
        {
          key: "title.id",
          label: "Title",
          sortable: true,
          class: "text-left"
        },
        {
          key: "content.id",
          label: "Content",
          sortable: true,
          class: "text-left"
        },
        {
          key: "order_field",
          label: "Order Number",
          sortable: true,
          class: "text-left"
        },
        {
          key: "updated_at_date_only",
          label: "Updated",
          sortable: true,
          class: "text-left"
        },
        { key: "action", label: "Action", class: "text-center w-15" }
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      sortBy: null,
      sortDesc: true,
      sortDirection: "asc",
      filter: "",
      id_category: "",
      dataTncCategory: [],
      customerShow: false,
      infoModal: {
        id: "info-modal",
        title: "",
        content: ""
      }
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }));
    }
  },
  mounted() {},
  beforeCreate() {
    const formData = new FormData();
    formData.append("search_param", "");
    formData.append("limit", 10);
    formData.append("page", 1);
    formData.append("sort_by", "");
    formData.append("is_sort_asc", "");
    this.$store
      .dispatch("TncCategoryModule/getTncCategorys", formData)
      .then(response => {
        this.dataTncCategory = response.data.data.results;
      })
      .catch(error => {
        this.$swal({
          type: "error",
          title: "Oops...",
          text: error.response.data.message,
          showConfirmButton: false,
          timer: 1500
        });
      });
  },
  created() {},
  methods: {
    TncFilter(payload) {
      if (payload == "") {
        this.$refs.selectableTable.refresh();
      } else {
        this.id_category = payload;
        this.$refs.selectableTable.refresh();
      }
    },
    getInfo(ctx, callback) {
      this.loading = true;
      const vm = this;
      const formData = new FormData();
      formData.append("search_param", ctx.filter);
      formData.append("limit", ctx.perPage);
      formData.append("page", ctx.currentPage);
      formData.append("sort_by", ctx.sortBy);
      formData.append("is_sort_asc", ctx.sortDesc);
      formData.append("tnc_category_id", this.id_category);
      this.$store
        .dispatch("TncContentModule/getTncContents", formData)
        .then(response => {
          // let arr = response.data.data.map(data => {
          //   let article = JSON.parse(data.results);
          //   return {
          //     content: article.content.id,
          //     title: article.title.id,
          //     category: article.category
          //   };
          // });
          // vm.items = arr;
          this.items = response.data.data.results;
          vm.totalRows = response.data.data.total_record;
          callback(response.data.data.results || []);
          this.loading = false;
        })
        .catch(error => {
          // Here we could override the busy state, setting isBusy to false
          // this.isBusy = false
          // Returning an empty array, allows table to correctly handle
          // internal busy state in case of error
          this.isBusy = false;
          callback([]);
        });
      return null;
    },
    getDetail(payload) {
      this.$store
        .dispatch("TncContentModule/getTncContent", payload)
        .then(response => {
          this.detail = response;
        })
        .catch(error => {
          console.log(error);
        });
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItemsweb.length;
      this.currentPage = 1;
    },
    del(payload) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!"
      }).then(result => {
        if (result.value) {
          this.$store.dispatch("TncContentModule/delTnc", payload);
          this.$refs.selectableTable.refresh();
          this.$swal("Deleted!", "Your file has been deleted.", "success");
        }
      });
    },
    orderTnc(order) {
      this.loading = true;
      const orderData = {
        change_type: order.change
      };
      this.$store
        .dispatch("TncContentModule/orderTnc", {
          id: order.id,
          orderData
        })
        .then(response => {
          this.$refs.selectableTable.refresh();
          this.$swal({
            type: "success",
            title: "Your work has been saved",
            showConfirmButton: false,
            timer: 1500
          });
          console.log(response);
        })
        .catch(error => {
          this.loading = false;
          this.$swal({
            type: "error",
            title: "Oops...",
            text: error.response.data.message,
            showConfirmButton: false,
            timer: 1500
          });
          console.log(error);
        });
    }
  }
};
</script>

<style>
</style>
